module.exports = __webpack_public_path__ + "static/image4-5d6758665600d5880f4df55af5f5793d.jpg";